import { useEffect } from "react";

export default function Terms() {

    useEffect(() => {
        window.location.replace('https://www.revolt.tv/terms-of-use');
    }, [])

    return (
        <div className="text-white text-lg">Redirecting...</div>
    )
}